import axios from '@/utils/axios';

// Types

// API

export default {
	async getAll(): Promise<any[]> {
		return (await axios().get(`/transactions/`)).data;
	},
	async getAllPending(): Promise<any[]> {
		return (await axios().get(`/transactions/?state=PENDING`)).data;
	},
};
